// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25cfe671","535":"34d71f20","801":"7db16a70"}[chunkId] + ".chunk.js";
};